module.exports = __webpack_public_path__ + "assets/7a2e0a2c69ea164e16ea69879c665ee5.png";